import { HomeSection, SliderItem } from "../../domain";
import { HomeContent } from "../../domain/repositories/home-repository";
import {
  Endpoints,
  HomeRemoteDataSourceError,
  RemoteDataSource,
} from "../core";

export class HomeRemoteDataSource extends RemoteDataSource {
  public async getHomeContent(): Promise<HomeContent> {
    try {
      const res = await this.get(Endpoints.home);
      return {
        slider: res.data.slider.map((json: any) =>
          new SliderItem().deserialize(json)
        ),
        sections: res.data.sections.map((json: any) =>
          new HomeSection().deserialize(json)
        ),
      };
    } catch (error) {
      if (!error.response) throw HomeRemoteDataSourceError.networkError();
      throw HomeRemoteDataSourceError.serverError();
    }
  }
}
